
import { css } from 'lit';
export default css`
:host {
  top: 0px;
  display: flex;
}@media (min-width: 1200px) {:host {
    position: -webkit-sticky;
    position: sticky;
  }
}
.sidebar-navigation {
  margin-top: 1.5rem;
  margin-right: 1rem;
  display: flex;
  max-height: 100vh;
  width: 100%;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
@media (min-width: 1200px) {.sidebar-navigation {
    margin-top: 4rem;
  }.sidebar-navigation {
    margin-right: 0px;
  }
}
.sidebar-navigation--mobile {
  display: block;
}
@media (min-width: 1200px) {.sidebar-navigation--mobile {
    display: none;
  }
}
.sidebar-navigation--desktop {
  display: none;
}
@media (min-width: 1200px) {.sidebar-navigation--desktop {
    display: block;
  }
}
.sidebar-navigation__flourish {
  position: relative;
}
.sidebar-navigation__flourish {
  margin-bottom: 0.75rem;
}
.sidebar-navigation__flourish {
  display: none;
}
.sidebar-navigation__flourish {
  flex-direction: column;
}
.sidebar-navigation__flourish-return {
  display: flex;
}
.sidebar-navigation__flourish-return:before {
  position: absolute;
}
.sidebar-navigation__flourish-return:before {
  z-index: 0;
}
.sidebar-navigation__flourish-return:before {
  display: block;
}
.sidebar-navigation__flourish-return:before {
  width: 100%;
}
.sidebar-navigation__flourish-return:before {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}
.sidebar-navigation__flourish-return:before {
        content: '';
        height: 8px;
        top: 6px;
      }
.sidebar-navigation__flourish-return > span {
  position: relative;
}
.sidebar-navigation__flourish-return > span {
  z-index: 10;
}
.sidebar-navigation__flourish-return > span {
  display: inline-block;
}
.sidebar-navigation__flourish-return > span {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.sidebar-navigation__flourish-return > span {
  padding-right: 0.5rem;
}
.sidebar-navigation__flourish-return > span {
  font-size: 0.65rem;
}
.sidebar-navigation__flourish-return > span {
  font-weight: 700;
}
.sidebar-navigation__flourish-return > span {
  text-transform: uppercase;
}
.sidebar-navigation__flourish-return > span {
  line-height: 2;
}
.sidebar-navigation__flourish-return > span {
  letter-spacing: 0.0625rem;
}
.sidebar-navigation__flourish-return > span {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
.sidebar-navigation__flourish a {
  display: flex;
}
.sidebar-navigation__flourish a {
  align-items: center;
}
.sidebar-navigation__flourish a {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
.sidebar-navigation__flourish a {
      margin-top: 0.375rem;
    }
.sidebar-navigation__flourish a span {
  font-size: 1.25rem;
}
.sidebar-navigation__flourish a span {
  font-weight: 700;
}
.sidebar-navigation__flourish a:hover {
  text-decoration: underline;
}
.sidebar-navigation__flourish-icon {
  position: absolute;
}
.sidebar-navigation__flourish-icon {
  --tw-rotate: 90deg;
  transform: var(--tw-transform);
}
.sidebar-navigation__flourish-icon {
  transform: var(--tw-transform);
}
.sidebar-navigation__flourish-icon {
      width: 11px;
      height: 7px;
      left: -20px;
      top: 18px;
      bottom: 0;
      margin: auto;
    }
@media (min-width: 1200px) {.sidebar-navigation__flourish {
    display: flex;
  }
}
.sidebar-navigation .sidebar-navigation--item a {
  font-size: 1.125rem;
}
.sidebar-navigation .sidebar-navigation--item a {
  font-weight: 400;
}
.sidebar-navigation .sidebar-navigation--item a {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
@media print {
.sidebar-navigation {
    display: none
}
  }
.sidebar-navigation--link {
  display: block;
  width: 100%;
  border-left-width: 3px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  text-align: left;
  font-size: 1.25rem;
  text-decoration: none;
}
.sidebar-navigation--link:hover {
  text-decoration: underline;
}
.sidebar-navigation--link.active {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
.sidebar-navigation--link.active {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.sidebar-navigation--link.active {
  font-weight: 900;
}
.top-sticky {
  position: relative;
  height: 56px;
}
@media (min-width: 1200px) {.top-sticky {
    position: fixed;
  }.top-sticky {
    top: 0px;
  }.top-sticky {
    height: auto;
  }.top-sticky {
    padding-top: 0px;
  }
}
.top-sticky .sidebar-navigation__select {
  position: fixed;
}
.top-sticky .sidebar-navigation__select {
  left: 0px;
}
.top-sticky .sidebar-navigation__select {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.top-sticky .sidebar-navigation__select {
  padding: 1rem;
}
.top-sticky .sidebar-navigation__select {
    top: 56px;
  }
.bottom-sticky {
  align-self: flex-end;
}
.select__link {
  display: block;
  border-left-width: 3px;
  border-color: transparent;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1.125rem;
}
.select__link:hover {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
.select__link:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}
details > summary {
  border: 1px solid #A4A7AB;
  cursor: pointer;
  list-style: none;
  line-height: 3em;
  display: flex;
  align-items: center;
  font-size: 18px;
  justify-content: space-between;
  padding-left: 1em;
  position: relative;
}
details > summary::-webkit-details-marker {
  display: none;
}
details > summary:after {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  position: absolute;
  top: 0;
  right: 0;
  width: 3em;
  height: 3em;
  content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24px' height='24px' fill='white'><path d='M21.17 5L12 14.17 2.83 5 0 7.83l12 12 12-12L21.17 5z'/></svg>");
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.5em;
}
details[open] > summary:after {
  transform: rotate(180deg);
}
`;